module.exports = __webpack_public_path__ + "static/img/bg-highlights-2.09ebcc3b.png";